import React from 'react';
import WhiteGreenWrapper from '../../../wrappers/WhiteGreenWrapper';
import { getImageSrc, getRetinaImgSrc } from '../../../core/helpers';
import { useTranslation } from 'react-i18next';
import MiscImg from '../../../images/misc.svg';
import { ReactComponent as ShieldIcon } from '../../../icons/shield.svg';
import './AmazonConnectionConsultation.scss';
import { useBookMeetingModal } from '../../../context/bookMeetingModalContext';
import Button from '../../../components/Button';

interface Props {
  onClickBtn: () => void;
}

export default function AmazonConnectionConsultation({ onClickBtn }: Props) {
  const { openModal } = useBookMeetingModal();
  const { t, i18n } = useTranslation();
  return (
    <WhiteGreenWrapper
      data-testid='amazon-connection-consultation'
      rightSideContent={
        <div className='pt-4'>
          <div className='text-center'>
            <img
              src={getImageSrc('/images/daniel-amazon-connect.png')}
              srcSet={getRetinaImgSrc('/images/daniel-amazon-connect-2x.png')}
              alt='AmazonConnectImage'
              className='AmazonConnection__image mx-auto'
            />
          </div>
          <div className='text-center mt-4 Text--20 text-white fw-800 mb-2'>
            Daniel Michael
          </div>
          <div
            className='text-center mx-auto mb-4'
            style={{
              maxWidth: i18n.language === 'en' ? 350 : 474,
            }}
          >
            {t(
              'Will help you to get data from the invoice system, process it and give an interpretation'
            )}
          </div>
          <img
            src={MiscImg}
            alt=''
            className='AmazonConnectionConsultation__misc mx-auto'
          />
        </div>
      }
      className='WhiteGreenWrapper--AmazonConnection'
    >
      <div
        style={{
          maxWidth: i18n.language === 'en' ? 506 : 552,
        }}
      >
        <div className='Title fw-900 mb-3'>
          {t('Book a free consultation with our manager')}
        </div>
        <div className='Text'>
          {t(
            "Unfortunately, we can't check your non-Amazon sales automatically, but we can do it manually."
          )}
        </div>
        <div className='Text mb-3'>
          {t(
            'Book a free consultation and our manager will explain how to provide your data for the setup check.'
          )}
        </div>
        {[
          'Select your time',
          'Get an instruction on data preparation',
          'Our manager reviews your data',
          'Manager interprets the results',
        ].map((p) => (
          <div className='Text mb-2 mb-lg-3 d-flex' key={p}>
            <ShieldIcon className='me-2 flex-shrink-0 mt-lg-1' />
            <div className='multiline-lg'>{t(p)}</div>
          </div>
        ))}
        <div className='row row-cols-auto pt-3'>
          <div className='col mb-3'>
            <Button className='Text px-4' onClick={openModal}>
              {t('Book a consultation')}
            </Button>
          </div>
          <div className='col d-flex align-items-center mb-3'>
            <Button
              styling='naked'
              className='ms-sm-3 Text'
              onClick={onClickBtn}
            >
              {t('connect_amazon_btn_text')}
            </Button>
          </div>
        </div>
      </div>
    </WhiteGreenWrapper>
  );
}
